function HelpCtrl($scope, Page) {
  'ngInject';

  Page.findOne({
    "filter": {
      "where": {
        "key": "help_direct"
      }
    }
  }).$promise.then(function(page) {
    $scope.questions = JSON.parse(page.body);
  }).catch(function(err) {
    console.error(err);
  });
}

export default HelpCtrl;



// WEBPACK FOOTER //
// ./js/containers/core/controllers/help.ctrl.js